<template>
  <div>
    <v-autocomplete
      v-model="localValue"
      :items="elementos"
      :item-text="nombrePais"
      :item-value="itemValue"
      outlined
      :label="label"
      :loading="loadingElemento"
      :disabled="loadingElemento || disabled"
      dense
      hide-details
      :filter="filterAutocomplete"
    >
      <template v-slot:selection="data">
        <img
          :src="`/img/flags/${data.item.bandera}`"
          alt="flag"
          class="flag-icon mr-2"
        />
        {{ nombrePais(data.item) }}
      </template>
      <template v-slot:item="data">
        <v-list-item-avatar tile>
          <img
            :src="`/img/flags/${data.item.bandera}`"
            alt="flag"
            class="flag-icon"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ nombrePais(data.item) }}</v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "VAutocompletePais",
  props: {
    value: {
      type: [String, null],
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    urlGet: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    nacionalidad: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localValue: this.value,
      elementos: [],
      loadingElemento: false,
      itemValue: "id_pais"
    };
  },
  watch: {
    value(newVal) {
      if (newVal !== this.localValue) {
        this.localValue = newVal;
      }
    },
    localValue(newVal) {
      if (newVal !== this.value) {
        this.$emit("input", newVal);
      }
    }
  },
  mounted() {
    this.getElementos();
  },
  methods: {
    nombrePais(item) {
      if (!item) return "";
      return this.nacionalidad
        ? `${item.nacionalidad} (${item.nombre})`
        : item.nombre;
    },
    getElementos() {
      this.loadingElemento = true;
      axios
        .get(this.urlGet)
        .then(response => {
          this.elementos = response.data;

          const existe = this.elementos.some(
            e => e[this.itemValue] === this.value
          );
          if (existe) {
            this.localValue = this.value;
          } else {
            console.warn(
              `⚠️ Valor inicial '${this.value}' no se encuentra en la lista de países.`
            );
            this.localValue = null;
          }
        })
        .catch(error => {
          console.error("Error al obtener elementos:", error);
          this.localValue = null;
        })
        .finally(() => {
          this.loadingElemento = false;
        });
    },
    normalize(str = "") {
      return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    filterAutocomplete(item, queryText, itemText) {
      const text = this.normalize(itemText);
      const query = this.normalize(queryText);
      return text.startsWith(query); // ← inicia con el texto, más rápido y controlado
    }
  }
};
</script>

<style scoped>
.flag-icon {
  height: 20px !important;
  width: auto;
  object-fit: contain;
}
</style>
